import React from 'react';
import { Menu, Icon } from '@sravni/react-design-system';
import { ArrowRight } from '@sravni/react-icons';
import { useStyles } from '@sravni/react-utils';
import { MenuItem } from './MenuItem.js';
import modules_cc53b92d from './SuggestList.module.less.js';

const SuggestList = ({ suggests, focusedIndex, onClick }) => {
    const cx = useStyles(modules_cc53b92d);
    return suggests.length ? (React.createElement(Menu, { className: modules_cc53b92d.menuContent }, suggests.map((item, index) => (React.createElement(MenuItem, { key: item.id, className: cx('menuItem', { focused: index === focusedIndex }), onClick: () => onClick(item.url, item.searchRequest) },
        React.createElement("span", { className: cx('menuItemLabel') }, item.searchRequest),
        React.createElement(Icon, { className: cx('menuItemIcon'), icon: React.createElement(ArrowRight, null) })))))) : null;
};

export { SuggestList as default };
//# sourceMappingURL=index.js.map
